import MobileChecker from './mobile-checker';
import { 
  computePosition, 
  shift, 
  limitShift,
  offset, 
  arrow, 
  flip,
} from '@floating-ui/dom';

class BaseHelpers {
  static html = document.documentElement;
  static header = document.querySelector('.header');
  static firstScreen = document.querySelector('[data-observ]');

  /**
   * Проверка браузера на поддержку .webp изображений
   * (i) необходимо для корректного отображения webp из css
   * */
  static checkWebpSupport() {
    /** Проверка поддержки webp */
    const testWebp = (callback) => {
      const webP = new Image();

      webP.onload = webP.onerror = () => callback(webP.height === 2);
      webP.src =
        'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';
    };

    /** Добавление класса _webp или _no-webp для HTML */
    testWebp((support) => {
      const className = support ? 'webp' : 'no-webp';
	    BaseHelpers.html.classList.add(className);

      console.log(support ? 'webp supported' : 'webp not supported');
    });
  }

  /**
   * Добавление класса touch для HTML если браузер мобильный
   * */
  static addTouchClass() {
    if (MobileChecker.isAny) {
	    BaseHelpers.html.classList.add('touch');
    }
  }

  /**
   * Добавление loaded для HTML после полной загрузки страницы
   * */
  static addLoadedClass() {
    window.addEventListener('load', () => {
      setTimeout(() => {
	      BaseHelpers.html.classList.add('loaded');
      }, 0);
    });
  }

  /** Получение хеша в адресе сайта */
  static get getHash() {
    return location.hash.replace('#', '');
  }

  /** Указание хеша в адресе сайта */
  static setHash(hash) {
    hash = hash ? `#${hash}` : location.href.split('#')[0];
    history.pushState('', '', hash);
  }

  /** Фіксований хедер з однозначною висотою підкладки */
  static headerFixed() {
    // data-observ height changer for header based on device
    const updateScreenSize = () => {
      const isMobile = window.innerWidth <= 992 ? true : false;
      BaseHelpers.firstScreen.classList.toggle('mobile', isMobile);
    };

    updateScreenSize();
    window.addEventListener('resize', updateScreenSize);
  }

  static isMobileScreen() {
    const screenWidth = window.innerWidth;

    return screenWidth <= 768 ? true : false;
  }

  /**
   * Mobile .main-navigation--mobile-list should be scrolled
   * into view of li.current-menu-item visited by user
   */
  static scrollIntoMobileNavActive() {
    const isMobile = window.innerWidth <= 840 ? true : false;
    const activeItem = document.querySelector('.main-navigation--mobile-list .current-menu-item');

    if (isMobile && activeItem) {
      activeItem.scrollIntoView(false);
    }
  }

  /**
   * Контент блоку data-placeholder має змінювати parent-а
   * в залежності від девайсу data-placeholder="desktop" || data-placeholder="mobile".
   */
  static placeholderReplacer() {
    const isMobile = BaseHelpers.isMobileScreen();
    const dataPlaceholder = document.querySelectorAll('[data-placeholder]');

    if (dataPlaceholder) {
      const placeholderDesktop = document.querySelectorAll('[data-placeholder="desktop"]');
      const placeholderMobile = document.querySelectorAll('[data-placeholder="mobile"]');

      if (isMobile) {
        placeholderDesktop.forEach((el, i) => {
          // const innerHtml = el.innerHTML;
          placeholderMobile[i].append(el);
        });
      }
    }
  }

  /**
   * .special-news__article should be append inside .special-news
   * at 768px width with some changes to it's layout 
   */
  static specialNewsReplacer() {
    const isMobile = BaseHelpers.isMobileScreen();
    const specialContainer = document.querySelector('.special-news');
    const specialArticle = document.querySelector('.special-news__article');

    if (Boolean(specialContainer) && Boolean(specialArticle) && isMobile) {
      const specialLi = document.querySelector('li:has(.special-news__article)');
      specialLi.remove();

      const specialIdentity = specialArticle.querySelector('.latest-article__identity');
      const specialTimeTag = specialArticle.querySelector('.latest-article__timestamps');
      specialTimeTag.prepend(specialIdentity);

      specialContainer.append(specialArticle);
    }
  }

  /** .creator в футері має рухатись в інший блок на мобільному */
  static creatorReplacer() {
    const isMobile = BaseHelpers.isMobileScreen();
    const mobileContainer = document.getElementById('creator-space');
    const desktopContainer = document.querySelector('.footer__info--end');
    const creatorElement = document.querySelector('.creator');

    if (creatorElement) {
      if (isMobile) {
        mobileContainer.append(creatorElement);
      } else {
        desktopContainer.append(creatorElement);
      }
    }
  }

  /** 
   * На мобільному девайсі категорії використовують splide,
   * даний метод щоб не грузити лібу на ПК де не треба
   * triggered on page load
   */
  static splideChecker() {
    const elementsWithSliderAttr = document.querySelectorAll('[data-slider="splide"]');
    const isSlidersNeeded = elementsWithSliderAttr.length && BaseHelpers.isMobileScreen();

    const updateSpliderClasses = () => {
      elementsWithSliderAttr.forEach((el) => {
        el.classList.toggle('splide', isSlidersNeeded);
      })
    }

    if (elementsWithSliderAttr.length) {
      updateSpliderClasses();
    }
  }

  /**
   * 768px width container toggling
   * if .container is exists it will be deleted and vice versa
   */
  static containerToggler() {
    const screenWidth = window.innerWidth;
    const searchContainer = document.querySelectorAll('[data-container="mobile"]');

    if (searchContainer.length && screenWidth <= 768) {
      searchContainer.forEach((container) => {
        container.classList.toggle('container');
      })
    }
  }

  /**
   * Post-pages can has .post__containless figures,
   * this method handles dynamic size changes for containless images
   */
  static containlessPostImages() {
    const isPost = document.querySelector('.post');
    const isPostWithSidebar = document.querySelector('.post--with-sidebar');
    const containless = document.querySelector('.post__containless');

    if (!Boolean(isPost) || !Boolean(containless) || Boolean(isPostWithSidebar)) {
      return;
    }

    const containlessImagesSizeChange = () => {
      // main.page, whole screen width
      const mainPageWidth = document.querySelector('main.page').getBoundingClientRect().width;
      // .post__containerless, size to the left screen border
      const containlessX = document.querySelector('.post__containless').getBoundingClientRect().x;

      const containlessImages = document.querySelectorAll('.post__containless__image');

      containlessImages.forEach((img) => {
        img.style.left = `-${containlessX}px`;
        img.style.width = `${mainPageWidth}px`;
      });
    }

    containlessImagesSizeChange();

    window.addEventListener('resize', containlessImagesSizeChange);
  }

  /**
   * Function to make .main-navigation header active link
   * that is current with proper underline
   */
  static navigationActive() {
    const mainNav = document.querySelector('.main-navigation');
    const menuLinks = mainNav.querySelectorAll('.menu__link');

    function activeNavPicker() {
      // Start index is -1 in the case thats aint menu__link page
      let neededMenuLinkIndex = -1;

      menuLinks.forEach((menuLink, i) => {
        if (menuLink.getAttribute('href').includes(window.location.pathname)) {
          neededMenuLinkIndex += (i + 1);
        }
      });

      // 4 is a last index of .menu__link that can be underlined
      if (neededMenuLinkIndex > 4) {
        neededMenuLinkIndex = 0;
      }

      if (menuLinks[neededMenuLinkIndex]) {
        menuLinks[neededMenuLinkIndex].parentElement.classList.add('menu__item--active');
      }
    }

    if (Boolean(mainNav)) {
      activeNavPicker();
    }
  }

  /**
   * If you need some element to be pasted after some quantity of articles
   * without interruption of the layout
   */
  static dynamicSectionExtractor() {
    const dynamicSection = document.getElementById('dynamic-section');
    const categoryPage = document.querySelector('.articles-category--page');
    // const searchPage = document.querySelector('.search-page');
    // const expertsPage = document.querySelector('.experts');

    if (Boolean(dynamicSection) && Boolean(categoryPage)) {
      insertDynamicByIndex('.articles-category__list li', '.populars');
    }

    // if (Boolean(dynamicSection) && Boolean(expertsPage)) {
    //   const expertsItems = document.querySelectorAll('.experts__item');
    //   const banners = dynamicSection.querySelector('.banner-container');

    //   if (Boolean(expertsItems[5])) {
    //     expertsItems[5].insertAdjacentElement('afterend', banners);
    //   }
    // }

    /**
     * @param {string} listItemsSelector 
     * @param {string} dynamicElementSelector 
     */
    function insertDynamicByIndex(listItemsSelector, dynamicElementSelector) {
      //get list of articles
      const listItems = categoryPage.querySelectorAll(listItemsSelector);
      const dynamicElement = dynamicSection.querySelector(dynamicElementSelector);
      
      // getting data attribute index value
      const indexToInsert = categoryPage.querySelector('[data-dynamic-section-after-index]');
      const index = Number(indexToInsert.getAttribute('data-dynamic-section-after-index'));

      if (Boolean(listItems[index])) {
        listItems[index].insertAdjacentElement('afterend', dynamicElement);
      }
    }
  }

  /** 
	 * floating-ui post-page tooltips initiator
	 * span.tooltip__reference
	 * div.tooltip__floating
	 */
  static floatingTooltips() {
    const tooltipReferences = document.querySelectorAll('.tooltip__reference');

    if (tooltipReferences.length) {
      const tooltipFloatings = document.querySelectorAll('.tooltip__floating');
      // const tooltipArrows = document.querySelectorAll('.tooltip__floating-arrow');

      tooltipReferences.forEach((el, i) => {
        const parent = tooltipReferences[i];
        const tooltip = tooltipFloatings[i];
        const closeBtn = tooltipFloatings[i].querySelector('.close-btn');

        function updatePosition(a, b) {
          computePosition(a, b, {
            placement: 'top',
            middleware: [
              offset({
                mainAxis: 16,
              }),
              flip({
                fallbackAxisSideDirection: 'start',
                crossAxis: false,
              }),
              shift(),
              // arrow({element: arrowElement}),
            ],
          }).then(({x, y, placement, middlewareData}) => {
            Object.assign(b.style, {
              left: `${x}px`,
              top: `${y}px`,
            });

            // const {x: arrowX, y: arrowY} = middlewareData.arrow;

            // const staticSide = {
            //   top: 'bottom',
            //   right: 'left',
            //   bottom: 'top',
            //   left: 'right',
            // }[placement.split('-')[0]];
          
            // Object.assign(arrowElement.style, {
            //   left: arrowX != null ? `${arrowX}px` : '',
            //   top: arrowY != null ? `${arrowY}px` : '',
            //   right: '',
            //   bottom: '',
            //   [staticSide]: '-4px',
            // });
          });
        }

        function showTooltip() {
          tooltip.style.display = 'block';
          updatePosition(parent, tooltip);
        }
        
        function hideTooltip() {
          tooltip.style.display = '';
        }
        closeBtn.addEventListener('click', hideTooltip);
        [
          // ['mouseenter', showTooltip],
          // ['mouseleave', hideTooltip],
          // ['focus', showTooltip],
          // ['blur', hideTooltip],
          ['click', showTooltip],
        ].forEach(([event, listener]) => {
          parent.addEventListener(event, listener);
        });
      })
    }
  }

  /**
   * Header navigation should hide on scrolldown 
   * and turn back on scrollup
   */
  static headerScrollUpTrigger() {
    const headerElement = document.querySelector('.header');
    const mobileCheckbox = document.getElementById('mobile-menu');

    const defaultHeaderHeight = `-${headerElement.offsetHeight}px`;
    let lastScrollTop = 0;

    window.addEventListener('scroll', function() {
      let currentScroll = window.scrollY || document.documentElement.scrollTop;
      
      if (currentScroll < lastScrollTop) {
        // Scrolling up
        headerElement.style.top = '0px';
      } else {
        // Scrolling down
        headerElement.style.top = defaultHeaderHeight;

        // Uncheck mobileCheckbox on scroll for mobile
        mobileCheckbox.checked = mobileCheckbox.checked === true ? false : null;
      }

      lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // For Mobile or negative scrolling
    }, false);
  }

  /**
   * .articles-category--page 1st article extractor
   */
  static firstArticleExtractor() {
    const isDesktop = !BaseHelpers.isMobileScreen();
    const articlesPage = document.querySelector('.articles-category--page');

    function replaceArticle() {
      const placeholder = articlesPage.querySelector('.articles-category__first-article');
      const articlesList = articlesPage.querySelector('.articles-category__list');
      const listItems = articlesList.querySelectorAll('li');
      let firstArticle;
      let firstLi;

      for (const li of listItems) {
        firstLi = li;
        firstArticle = li.querySelector('article.article');
        break;
      }

      if (!firstArticle || !firstLi) {
        console.log('First li with first article is undefined');
        return;
      }

      if (!placeholder) {
        console.log('placeholder .articles-category__first-article is undefined');
        return;
      }

      placeholder.append(firstArticle);
      firstLi.remove();
    };

    if (isDesktop && Boolean(articlesPage)) {
      replaceArticle();
    }
  }
}

export default BaseHelpers;
